import { StyledLinkableToastMessage } from './LinkableToastMessage.styles';

export const LinkableToastMessage = ({
  message,
  onClick,
  linkText,
}: {
  message: string;
  linkText: string;
  onClick?: () => void;
}): JSX.Element => (
  <StyledLinkableToastMessage>
    <div>{message}</div>
    <div className='linkable-toast-message-text' onClick={onClick}>
      {linkText}
    </div>
  </StyledLinkableToastMessage>
);
